<template>
	<div class="page-content">
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>智慧服务</el-breadcrumb-item>
			<el-breadcrumb-item :to="{ path: '/Complaint' }">知识产权投诉</el-breadcrumb-item>
			<el-breadcrumb-item>知识产权投诉信息</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="activity-search">
      <el-row :gutter="10" type="flex" justify="space-between">
				<el-col :span="8">
          <span class="g-search-gap">所属平台</span>
          <el-select size="small" v-model="platform" placeholder="全部" class="input-width">
						<el-option :value="null" label="全部"></el-option>
            <el-option v-for="item in plateList" :key="item.dictCode" :value="item.dictCode" :label="item.dictName" v-show="item.pricename">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8" class="position-right">
          <span class="g-search-gap">店铺名称</span>
          <el-input size="small" v-model="shopname" clearable placeholder="请输入" class="input-width"></el-input>
        </el-col>
				<el-col :span="8" class="position-right">
          <span class="g-search-gap">投诉时间</span>
          <el-date-picker
						style="width: 220px;"
            size="small"
            value-format="yyyy-MM-dd"
            v-model="committime"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
						:clearable='false'
          >
          </el-date-picker>
        </el-col>
      </el-row>
			<el-row class="position-top position-right">
        <el-button size="small" plain @click="getComplaintNewList(1)" >查询</el-button>
			</el-row>
    </div>
		<div class="tabs">
			<el-row type="flex" justify="space-between">
				<div class="notice-wrap" style="width: 100%;">
					<i class="el-icon-warning" style="display:inline-block;margin-right:5px;"></i>
					共 <span style="font-size: 16px;color: #4a4b4c;">{{totalElements}}</span> 项知识产权投诉商品链接
				</div>
				<el-button class="g-margin-left" style="margin-left: 10px;" size="small" plain @click="download">下载数据</el-button>
			</el-row>
			<!--表格-->
			<el-table ref="multipleTable" :data="tableList" style="width: 100%;margin-top: 5px;">
				<el-table-column label="序号" align="left" type="index" width="50">
					<template slot-scope="scope">
            {{scope.$index | indexMethod(list.pageNo,list.pageSize)}}
          </template>
				</el-table-column>
				<el-table-column label="商品信息" prop="itemtitle" width="480">
					<template slot-scope="scope" class="shopInfo">
						<div class="shopMain" v-if="scope.row.itemtitle && scope.row.itemtitle != ''">
							<img :src="scope.row.logopicurl_details?scope.row.logopicurl_details:scope.row.logopicurl" alt/>
							<div class="content">
								<el-link class="align_left" :underline="false" :href="scope.row.itemlink" type="primary" target="_blank">
									{{scope.row.itemtitle_details?scope.row.itemtitle_details:scope.row.itemtitle}}
								</el-link>
								<div class="align_left">
									{{scope.row.productname}}
								</div>
							</div>
						</div>
						<div class="shopMain" v-else>
							<el-link class="align_left" :underline="false" :href="scope.row.itemlink" type="primary" target="_blank">
								{{scope.row.itemlink}}
							</el-link>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="name" label="价格">
					<template slot-scope="scope">
						<div v-if="scope.row.price">
							标价：¥ {{scope.row.price}}
						</div>
						<!-- <div v-if="scope.row.contrastprice | scope.row.contrastprice != '0.0'"> -->
						<div v-if="scope.row.contrastprice">
							到手价：¥ {{scope.row.contrastprice}}
						</div>
					</template>
				</el-table-column>
				<el-table-column label="店铺名称" show-overflow-tooltip>
					<template slot-scope="scope">
						<div v-if="scope.row.shopname" class="align_left ellipsis">{{scope.row.shopname}}</div>
						<div v-else class="align_left ellipsis">/</div>
						<div v-show="scope.row.wangwang && $route.query.platformCode == 'TBTM'" class="align_left ellipsis">{{scope.row.wangwang}}</div>
						<div class="tall_icon">
							<img :src="require('@/assets/img/platform/pla_'+scope.row.platform+'.png')" class="edit_icon"/>
							<span class="green" v-show="scope.row.authorize">{{scope.row.authorize}}</span>
							<span class="green" v-show="scope.row.authorize">{{scope.row.authorize}}</span>
							<span class="grey" v-show="scope.row.shoptype=='灰名单'">灰</span>
							<span class="black" v-show="scope.row.shoptype=='黑名单'">黑</span>
							<span class="green" v-show="scope.row.shoptype== '授权店铺'">授权</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="投诉信息">
					<template slot-scope="scope">
						<div v-if="scope.row.createusername">
							投诉人：{{scope.row.createusername}}
						</div>
						<div v-if="scope.row.complain_no">
							投诉批号：{{scope.row.complain_no}}
						</div>
						<div v-if="scope.row.createtime">
							投诉时间：{{scope.row.createtime | fullTime}}
						</div>
					</template>
				</el-table-column>
			</el-table>
			<pagination
        v-if="tableList&&tableList.length>0"
        :currentPage="currentPage"
        :pageSizes="[10, 20, 30, 40]"
        :total="totalElements"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></pagination>

		</div>
	</div>
</template>

<script>
import pagination from "../../../components/dataTable/pagination";
import { mapGetters, mapActions } from 'vuex';
import { getTodayOneMonth } from '@/libs/date'
export default {
	name: 'ComplaintDataSummary',

	components: {
    pagination
  },

	data () {
		return {
			pagination: {
        size: 10,
        current: 1
      },
			currentPage: 0,
			breadcrumbArray: ['智慧服务', '违规通知复查', '违规通知详情'],
			search: {},
			committime: [],
			plateList: [],
			totalElements: '',
			complain_no: '',
			createusername: '',
			endtime: this.$route.query.endtime,
			pageNo: 1,
			pageSize: 10,
			platform: null,
			shopname: '',
			starttime: this.$route.query.starttime,
			tableList: [],
		}
	},
	methods: {
		// 下载
		download() {
			let datas={
				endtime: this.endtime,
				starttime: this.starttime,
				complain_no: '',
				createusername: '',
			}
			if (this.platform) {
				datas.platform = this.platform
			}
			if (this.shopname) {
				datas.shopname = this.shopname
			}
			fetch({
					url: "hcm/complaint/downComplaintNewListdownComplaintNewList",
					method: "get",
					params:datas,
					noFormat: true,
					responseType: "blob"
			})
			.then((res)=>{
				//下载
				let url = window.URL.createObjectURL(new Blob([res]))
				let link = document.createElement('a')
				link.style.display = 'none'
				link.href = url
				link.setAttribute('download', '知识产权投诉信息.xlsx')
				document.body.appendChild(link)
				link.click()
			})
		},
		getComplaintNewList(e) {
			if (this.committime) {
				this.endtime = this.committime[0]
				this.starttime = this.committime[1]
			}
			let params={
				pageNo: this.pageNo,
				pageSize: this.pageSize,
				endtime: this.endtime,
				starttime: this.starttime,
			}
			if (this.platform) {
				params.platform = this.platform
			}
			if (this.shopname) {
				params.shopname = this.shopname
			}
			fetch({
				url: "hcm/complaint/getComplaintNewList",
				method: "get",
				params: params,
				noFormat: true,
				responseType: "text"
			}).then(result => {
				let res = JSON.parse(result);
				let {data}=res
				if(res.status == '10000'){
					this.tableList = res.data.content
					this.totalElements = res.data.totalElements
				}
			})
		},
		// 平台
		GetList() {
			let params={
				dictcode: 'platform',
				pricename: 'main',
			}
			fetch({
				url: "hcm/sys/GetList",
				method: "get",
				params: params,
				noFormat: true,
				responseType: "text"
			}).then(result => {
				let res = JSON.parse(result);
				let {data}=res
				if(res.status == '10000'){
					this.plateList = res.data
				}
			})
		},
		//每页
    handleSizeChange(val) {
      this.pageSize = val;
      this.getComplaintNewList();
    },
    //当前页
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getComplaintNewList();
    },
	},
	created() {
		this.committime = getTodayOneMonth();
	},

	mounted() {
		this.committime = []
		this.committime.push(this.$route.query.endtime)
		this.committime.push(this.$route.query.starttime)
		this.getComplaintNewList()
		this.GetList()
	},
}
</script>


<style lang='scss'>
@import "style/activityApproval.scss";
.shopMain {
	display: flex;
	justify-content: flex-start;
	align-items: center;
	margin-bottom: 5px;
	.content {
		width: calc(100% - 58px);
	}
	img {
		width: 66px;
		height: 58px;
		margin-right: 5px;
		display: block;
	}
}
</style>
